require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-miles-starkenburg.json") })
        }
      }, "path---blog-author-miles-starkenburg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-miles-starkenburg!./.cache/json/blog-author-miles-starkenburg.json
// module id = 685
// module chunks = 231608221292675